import React, {Component} from 'react';
import style from '../css/gamePosters.css';
import {VIRTUALS} from '../../../constants/games';
import {ASSETS_URL} from '../../../constants/endpoints';
import {selectGame} from "../../../actions/gamesActions";
import connect from "react-redux/es/connect/connect";
import {getPromoBannerArray} from "../helpers/promoToolHelper";
import {openTermsAndConditions, setSelectedTCPromoId} from "../../../actions/promoBetActions";
import {openCloseAccumulatorBoost} from "../../../actions/accumulatorBoostAction";
import {getGameCategoryIndex} from '../helpers/gameHelpers';

let isClickable = true;
let gameCategories = [];

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        isBetSlipModalOpen: state.vpp.isBetSlipModalOpen,
        promoBalances: state.vpp.promoBalances,
        betSlipModalContainerHeight:state.vpp.betSlipModalContainerHeight,
        systemLanguage: state.vpp.systemLanguage
    };
};

class GamePosters extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
            promoBalances: storeData.vpp.promoBalances,
            betSlipModalContainerHeight: storeData.vpp.betSlipModalContainerHeight,
            systemLanguage:storeData.vpp.systemLanguage
        };

        VIRTUALS.map((game, index) => {
            game.actualIndex = index;
            if (gameCategories && gameCategories.length > 0 && gameCategories[gameCategories.length - 1].name === game.category.name) {
                gameCategories[gameCategories.length - 1].games.push(game);
            } else {
                let gameCategory = new Object({});
                gameCategory.name = game.category.name;
                gameCategory.order = game.category.displayOrder;
                if (!gameCategory.games) {
                    gameCategory.games = [];
                }
                gameCategory.games.push(game);
                gameCategories.push(gameCategory);
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (this.state.selectedGameIndex !== undefined && this.state.selectedGameIndex !== storeData.vpp.selectedGameIndex) {
            let e = document.getElementById('gameTab_' + storeData.vpp.selectedGameIndex);
            if (e) {
                e.scrollIntoView();
            }
        }

        if (nextProps && storeData) {
        this.setState({
            ...this.state,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
            promoBalances: storeData.vpp.promoBalances,
            betSlipModalContainerHeight:storeData.vpp.betSlipModalContainerHeight,
            systemLanguage:storeData.vpp.systemLanguage
        });
        }

    }

    _scrollGameTabs(gameIndex) {
        if (gameIndex !== undefined) {
            let gameTabsContainer = document.getElementById('gameTabsContainer');
            let tab = document.getElementById('gameCategoryTab_' + getGameCategoryIndex(gameIndex));
            let scrollDistance = tab.offsetWidth * getGameCategoryIndex(gameIndex);
            gameTabsContainer.scrollTo({left: scrollDistance, behavior: 'smooth'});
        }
    }

    _clickTab(index) {
        if (this.props.store && isClickable) {
            isClickable = false;
            setTimeout(() => {
                isClickable = true
            }, 300);
            this.props.store.dispatch(selectGame(index, this.props.store));
            this._scrollGameTabs(index);
        }
    }

    handleError(){
            document.getElementById('accaboostBannerCheck').style.visibility="hidden";
    }

    render() {
        let store = this.props.store;
        const handleClick = (id)=> {
            if(id === 'Accaboost')
                store.dispatch(openCloseAccumulatorBoost())
            else {
                store.dispatch(setSelectedTCPromoId(id));
                store.dispatch(openTermsAndConditions());
            }
        }
     	let bannerArray = getPromoBannerArray(this.state.promoBalances ,'desktop', this.state.systemLanguage);
        let containerStyle =(store.getState().vpp.isBetSlipModalOpen) ? style.openBetSlipContainer : style.gamePostersContainer;
       //for pushing side banner in windows
        if (this.state.betSlipModalContainerHeight > 0) {
            // 46px is the size of closed betslip container
           let betSlipClosedMsgHeight =  (document.getElementById("matchdayEventTabs"))
               ? document.getElementById("matchdayEventTabs").clientHeight
               : (document.getElementById("gamesubTab_7"))
                   ? document.getElementById("gamesubTab_7").clientHeight
                   : 46;
            let betSlipModalHeight = this.state.betSlipModalContainerHeight - betSlipClosedMsgHeight ;
            document.getElementById("gamePostersContainer") ? document.getElementById("gamePostersContainer").style.marginTop = `${betSlipModalHeight}px` : '';
        }
        if(!this.state.isBetSlipModalOpen){
            document.getElementById("gamePostersContainer") ? document.getElementById("gamePostersContainer").style.marginTop = `0px` : '';
        }
        if(bannerArray.length === 0) {
            return (<div className={containerStyle} id='gamePostersContainer'>
                <div id={this.props.id}>
                    {gameCategories.map((gameCategory, index) => (
                        <div key={index} onClick={() => {
                            this._clickTab(gameCategory.games[0].actualIndex)
                        }}>
                            {
                                <div className={style.imageBannerContainer}>
                                    <img className={style.imageBanner} src={`${ASSETS_URL}${gameCategory.games[0].URL.BMS_ASSETS}/poster.png`}/>
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </div>);
        }else if (bannerArray.length === 1 && bannerArray[0].id === "Accaboost") {
            return (<div className={containerStyle} id='gamePostersContainer'>
                <div className={style.imageBannerContainer}>
                    <img onError = {this.handleError} onClick={() => {
                        handleClick(bannerArray[0].id)
                    }}className={style.imageBanner} src={bannerArray[0].img} id = 'accaboostBannerCheck'/>
                    </div>
                    <div id={this.props.id}>
                        {gameCategories.map((gameCategory, index) => (
                            <div key={index} onClick={() => {
                                this._clickTab(gameCategory.games[0].actualIndex)
                            }}>
                                {
                                    <div className={style.imageBannerContainer}>
                                        <img className={style.imageBanner} src={`${ASSETS_URL}${gameCategory.games[0].URL.BMS_ASSETS}/poster.png`} />
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                
            </div>);
        }
        return (<div className={containerStyle} id='gamePostersContainer'>
            <div id={this.props.id}>
                {bannerArray.map((step, index) => (
                    <div key={step.id} onClick={() => {
                        handleClick(step.id)
                    }}>
                        {
                            <div className={style.imageBannerContainer}>
                                <img className={style.imageBanner} src={step.img}/>
                            </div>
                        }
                    </div>
                ))}
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(GamePosters);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/gamePosters.js